import PT from 'prop-types';

import { FileType } from './file';

export const ItemType = PT.shape({
	id: PT.string.isRequired,
	categoryId: PT.string.isRequired,
	name: PT.string.isRequired,
	subtitle: PT.string.isRequired,
	image: FileType.isRequired,
	mobileImg: FileType.isRequired,
	audio: FileType.isRequired,
	order: PT.number.isRequired,
	content: PT.shape({
		text: PT.string,
		textRaw: PT.string,
	}).isRequired,
});
